<template>
  <w-icon-wrapper icon-name='work-upload-icon'>
    <g
      id='_23_Upload_Icon'
      data-name='23 Upload_Icon'
      transform='translate(-0.108)'
    >
      <path
        id='Pfad_55691'
        d='M23.117,15a1,1,0,0,0-.991,1v6H2.09V16A.991.991,0,1,0,.108,16v8h24V16A1,1,0,0,0,23.117,15Z'
        data-name='Pfad 55691'
        fill='currentColor'
      />
      <path
        id='Pfad_55692'
        d='M11.964,0l.691.7c.027.025.052.05.077.078l2.94,2.987A1.031,1.031,0,0,1,15.678,5.2a.974.974,0,0,1-1.4.006L12.992,3.9V18.7a.991.991,0,1,1-1.982,0V3.919L9.739,5.259a.976.976,0,0,1-1.4.019,1.033,1.033,0,0,1-.02-1.435Z'
        data-name='Pfad 55692'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconUpload' };
</script>
